function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-925-1586H995v2651H-925z"
}), React.createElement("path", {
  d: "M-926-1279H994v2286H-926z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("path", {
  d: "M130.274 85.523h-1.746v-2.62c0-.524-.35-.873-.873-.873h-1.747v-6.987h4.366c.262 0 .524-.087.7-.349.174-.262.261-.524.174-.786l-3.493-12.226c-.175-.35-.524-.611-.874-.611H83.117c-.35 0-.7.262-.874.61L78.75 73.909c0 .262 0 .524.175.786.174.262.436.35.698.35h4.367v6.986h-1.747c-.524 0-.873.349-.873.873s.35.873.873.873h1.747v28.819c0 .524.349.873.873.873h3.493c.524 0 .873-.35.873-.873V83.776h3.494v.873c0 .524.349.874.873.874h3.493v10.48h-5.24c-.524 0-.873.348-.873.872v15.72c0 .524.35.873.873.873h26.199c.524 0 .874-.35.874-.873v-15.72c0-.524-.35-.873-.874-.873H98.836v-10.48h17.466c.524 0 .873-.349.873-.873v-.873h3.493v28.819c0 .524.35.873.873.873h3.494c.524 0 .873-.35.873-.873V83.776h.873v2.62c0 .524.35.873.873.873h2.62c.524 0 .873-.35.873-.873 0-.524-.349-.873-.873-.873zm-29.692 17.466h3.493v3.493H97.09v-3.493h3.493zm8.733 0h3.493v3.493h-6.986v-3.493h3.493zm7.86 0v3.493h-2.62v-3.493h2.62zm-21.832 3.493h-2.62v-3.493h2.62v3.493zm-2.62 1.746h6.986v3.493h-6.986v-3.493zm8.733 0h6.986v3.493h-6.986v-3.493zm15.719 3.494h-6.986v-3.494h6.986v3.494zm0-10.48h-6.986V97.75h6.986v3.493zm-8.733 0h-6.986V97.75h6.986v3.493zm-8.733 0h-6.986V97.75h6.986v3.493zm24.452-19.212h-1.746v-6.987h1.746v6.987zM83.815 62.817h42.267l2.97 10.48H80.759l3.056-10.48zm1.921 12.226h1.747v6.987h-1.747v-6.987zm1.747 36.679h-1.747V83.776h1.747v27.946zm6.986-27.946V82.03h2.62v1.746h-2.62zm4.367-1.746h1.746v1.746h-1.746V82.03zm5.24 0v1.746h-1.747V82.03h1.747zm11.352 1.746h-9.606V82.03h9.606v1.746zm1.747-1.746v-.874c0-.524-.35-.873-.873-.873H93.596c-.524 0-.873.35-.873.873v.874H89.23v-6.987h31.438v6.987h-3.493zm6.986 29.692h-1.746V83.776h1.746v27.946z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 48.288,
  y: 138.719
}, "Odwiert/studnia")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/odwiert.21caa6c8.svg";
export { SvgComponent as ReactComponent };